import { IconGroup, IIconGroupProps } from "./IconGroup";
import * as S from "./styles.ts";

type TIconGroupIcons = IIconGroupProps["icons"];

export type IIconGroup = {
  label?: string;
  icons: TIconGroupIcons;
};

interface IIconsProps {
  groups: IIconGroup[];
}

const Icons = ({ groups }: IIconsProps) => {
  return (
    <S.IconsColumn>
      {groups.map((group, i) => (
        <S.Section key={i}>
          {group.label && <S.SectionTitle>{group.label}</S.SectionTitle>}
          <IconGroup
            icons={group.icons}
            compact
          />
        </S.Section>
      ))}
    </S.IconsColumn>
  );
};

export default Icons;
